import { useIntersectionObserver } from 'src/common/hooks/useIntersectionObserver'
import { useAnalytics } from 'src/common/analytics'
import Section from 'src/components/shared/Section'
import { Fragment } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

export const onViewH2Id = 'by-the-numbers-section'

const ByTheNumbersSection = () => {
  const router = useRouter()
  const { track } = useAnalytics()
  const { ref } = useIntersectionObserver({
    threshold: 0.8,
    freezeOnceVisible: true,
    onChange: (isIntersecting) => {
      if (!isIntersecting) return
      track(
        { additional_info: { section: onViewH2Id }, event_type: 'track' },
        {},
        'section_view'
      )
    },
  })

  const onClick = (e) => {
    e.preventDefault()

    const data = {
      click_id: 'Frequently asked questions',
      click_text: 'FDR-Web | Frequently asked questions',
      click_type: 'Button Click',
      click_url: 'https://www.freedomdebtrelief.com/faq/',
      event_action: 'click',
      event_type: 'track',
    }

    track?.(data, {}, 'button_click')

    router.push('/faq')
  }

  return (
    <Section className="bg-[#F5F9FF]">
      <div
        className="flex w-full flex-col items-center gap-8 font-ultramarine text-gray-555 lg:gap-14"
        data-testid="facts-by-the-numbers-content"
      >
        <h2
          ref={ref}
          className="text-center text-heading-3 font-bold leading-[31.2px] text-gray-555 lg:text-left lg:text-heading-2 lg:leading-[41.6px]"
          data-testid="facts-by-the-numbers-title"
        >
          Freedom Debt Relief by the numbers
        </h2>

        <div
          className="flex w-full flex-col items-center gap-0 lg:gap-14"
          data-testid="facts-by-the-numbers-list"
        >
          {CHUNKS.map((item, i) => (
            <div
              key={'chunk-' + i}
              className="flex w-full flex-col items-center xl:flex-row"
              data-testid="facts-by-the-numbers-row"
            >
              {item.map((item, i2) => (
                <Fragment key={item.title}>
                  {i2 > 0 && (
                    <div className="mx-11 hidden h-[158px] w-px bg-gray-145 xl:block" />
                  )}
                  {(i2 > 0 || i > 0) && (
                    <div className="my-8 block h-px w-full bg-gray-145 xl:hidden" />
                  )}
                  <div
                    className="flex min-w-[303px] flex-col items-center"
                    data-testid="facts-by-the-numbers-item"
                  >
                    <p
                      className="whitespace-nowrap text-heading-2 font-medium leading-[41.6px] lg:text-primary-md lg:leading-[57.6px]"
                      data-testid="facts-by-the-numbers-value"
                    >
                      {item.title}
                    </p>
                    <p
                      className="text-[15px] font-normal leading-[25.5px] lg:text-body-medium lg:leading-[22.4px]"
                      data-testid="facts-by-the-numbers-label"
                    >
                      {item.description}
                    </p>
                  </div>
                </Fragment>
              ))}
            </div>
          ))}
        </div>
        <Link
          href={'/faq/'}
          className="w-full lg:w-fit"
          prefetch={false}
          onClick={onClick}
          data-testid="facts-by-the-numbers-cta-link"
        >
          <button
            className="w-full rounded-lg bg-blue-585 px-6 py-3 text-lg font-bold text-white lg:w-fit"
            data-testid="facts-by-the-numbers-cta-button"
          >
            Frequently asked questions
          </button>
        </Link>
        <div
          className="flex max-w-[642px] flex-col gap-6 text-12 leading-[16.8px] text-neutral-300"
          data-testid="facts-by-the-numbers-disclaimer"
        >
          <p className="text-center">
            Statistics reflect the results of the clients we and our affiliates
            have served since 2002 (as of January 2025).
          </p>
        </div>
      </div>
    </Section>
  )
}

export default ByTheNumbersSection

const CHUNKS = [
  [
    {
      title: '24 to 48 mos',
      description: 'Program length (39 months on avg.)',
    },
    {
      title: '$7,500',
      description: 'minimum debt required ',
    },
    {
      title: '8',
      description: 'debts enrolled on average',
    },
  ],
  [
    {
      title: '$427',
      description: 'average monthly program deposit',
    },
    {
      title: '60%+ clients',
      description: 'get their 1st settlement within 3 months',
    },
    {
      title: '15%-25%',
      description: 'Fee range of enrolled debt',
    },
  ],
]
